(() => {
  const planLabels = {
    '795050161': '月1回',
    '1449689265': '3週間に1回',
    '795148465': '2週間に1回',
    '795181233': '毎週'
  };

  const buildBuyUrl = (variantId, planId) => {
    const url = new URL('/apps/subscription/buy', window.location.origin);
    url.searchParams.set('id', variantId);
    url.searchParams.set('selling_plan', planId);
    url.searchParams.set('quantity', '1');
    return url.toString();
  };

  document.querySelectorAll('[data-lp40sub]').forEach((root) => {
    const select = root.querySelector('[data-frequency-select]');
    const buyLinks = [...root.querySelectorAll('[data-buy-link]')];
    const sticky = root.querySelector('[data-sticky-offer]');
    const stickyFrequency = root.querySelector('[data-sticky-frequency]');
    const hero = root.querySelector('.lp40sub__hero');
    const purchaseBlocks = [...root.querySelectorAll('[data-purchase-block]')];
    const variantId = root.dataset.variantId;

    if (!select || !variantId) return;

    const updatePlan = () => {
      const planId = select.value;
      const label = planLabels[planId] || '選んだ頻度';
      const url = buildBuyUrl(variantId, planId);

      buyLinks.forEach((link) => {
        link.href = url;
        const labelNode = link.querySelector('[data-buy-label]');
        if (labelNode) labelNode.textContent = `${label}で申し込む`;
      });
      if (stickyFrequency) stickyFrequency.textContent = label;
    };

    select.addEventListener('change', updatePlan);
    updatePlan();

    if (!sticky || !hero || !('IntersectionObserver' in window)) return;

    const mobile = window.matchMedia('(max-width: 767px)');
    let heroVisible = true;
    const visiblePurchaseBlocks = new Set();

    const renderSticky = () => {
      const show = mobile.matches && !heroVisible && visiblePurchaseBlocks.size === 0;
      sticky.hidden = !show;
      root.classList.toggle('lp40sub--sticky-active', show);
    };

    const heroObserver = new IntersectionObserver(([entry]) => {
      heroVisible = entry.isIntersecting;
      renderSticky();
    }, { threshold: 0.05 });

    const purchaseObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) visiblePurchaseBlocks.add(entry.target);
        else visiblePurchaseBlocks.delete(entry.target);
      });
      renderSticky();
    }, { threshold: 0.08 });

    heroObserver.observe(hero);
    purchaseBlocks.forEach((block) => purchaseObserver.observe(block));
    if (typeof mobile.addEventListener === 'function') {
      mobile.addEventListener('change', renderSticky);
    } else {
      mobile.addListener(renderSticky);
    }
  });
})();
